export default __webpack_public_path__ + "static/media/img-5.5ca7e93c.jpg";